module.exports = __webpack_public_path__ + "img/activities.70d28721.png";